import { render, staticRenderFns } from "./super_topbar.vue.js?vue&type=template&id=03d75926!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_topbar.vue?vue&type=template&id=03d75926"
import script from "./super_topbar.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_topbar.vue?vue&type=script&lang=js"
export * from "./super_topbar.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_topbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d75926')) {
      api.createRecord('03d75926', component.options)
    } else {
      api.reload('03d75926', component.options)
    }
    module.hot.accept("./super_topbar.vue.js?vue&type=template&id=03d75926!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_topbar.vue?vue&type=template&id=03d75926", function () {
      api.rerender('03d75926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/super_topbar.vue"
export default component.exports